import * as React from "react";
import { useParams } from "react-router-dom";
import { ParamBrandHouse } from "../../../Parameters";
import { FormProvider, useForm } from "react-hook-form";
import {
   Dialog,
   DialogTitle,
   DialogContent,
   DialogActions,
   Button,
   Box
} from "@mui/material";
import { FormInputPrice } from "../../shop/wholesale/form/FormInputPrice";
import { FormInputText } from "../../shop/wholesale/form/FormInputText";
import { useInvoiceAdjustmentCreateMutation, CreateOneInvoiceAdjustmentInput } from "../../../Queries";
import { SavingUI } from "../../../SavingProvider";

interface AdjustmentCreateDialogProps {
   open: boolean;
   onClose: () => void;
   onCreated: () => void;
}

interface FormData {
   amount: number;
   description: string;
}

export const AdjustmentCreateDialog = ({ open, onClose, onCreated }: AdjustmentCreateDialogProps) => {
   const { brandHouseId } = useParams<ParamBrandHouse>();
   const [createAdjustment] = useInvoiceAdjustmentCreateMutation();

   const methods = useForm<FormData>({
      defaultValues: {
         amount: 0,
         description: ""
      }
   });

   const { handleSubmit, reset } = methods;

   const onSubmit = async (data: FormData) => {
      const input: CreateOneInvoiceAdjustmentInput = {
         brandHouseId: brandHouseId!,
         amount: data.amount,
         description: data.description
      };

      await SavingUI.process(async () => {
         await createAdjustment({
            variables: {
               input
            }
         });
      }, 'Adjustment created successfully');

      reset();
      onCreated();
   };

   const handleClose = () => {
      reset();
      onClose();
   };

   return (
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
         <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
               <DialogTitle>Create Invoice Adjustment</DialogTitle>
               <DialogContent>
                  <Box sx={{ pt: 2 }}>
                     <FormInputPrice 
                        name="amount" 
                        label="Amount (DKK)" 
                        required
                        helperText="Positive for additional costs, negative for credits/discounts"
                        allowNegative={true}
                     />
                     <FormInputText
                        name="description"
                        label="Description"
                        required
                        multiline
                        rows={3}
                     />
                  </Box>
               </DialogContent>
               <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button type="submit" variant="contained" color="primary">
                     Create
                  </Button>
               </DialogActions>
            </form>
         </FormProvider>
      </Dialog>
   );
};